import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SearchComponent } from './search/search.component';
import { RenewalComponent } from './application/renewal/renewal.component';
import { InitialComponent } from './application/initial/initial.component';
import { RequestCopyComponent } from './application/request-copy/request-copy.component';
import { CreateComponent } from './application/create/create.component';
import { ExternalPaymentComponent } from './application/external-payment/external-payment.component';
import { MailinPaymentConfirmationComponent } from './application/mailin-payment-confirmation/mailin-payment-confirmation.component';
import { PaymentfailedComponent } from './application/paymentfailed/paymentfailed.component';
import { ExemptionPayNowComponent } from './application/exemption-pay-now/exemption-pay-now.component';
import { RegistryDownloadComponent } from './application/registry-download/registry-download.component';
import { RegistryDownloadPaymentComponent } from './application/registry-download-payment/registry-download-payment.component';
import { DownloadpaymentfailedComponent } from './application/registry-download/downloadpaymentfailed/downloadpaymentfailed.component';
import { DownloadpaymentconfirmationComponent } from './application/registry-download/downloadpaymentconfirmation/downloadpaymentconfirmation.component';


const routes: Routes = [
  {path: '', component: SearchComponent },
  {path: 'search', component: SearchComponent },
  {path: 'create/:type', component: CreateComponent },
  {path: 'initial/:id', component: InitialComponent},
  {path: 'renewal/:id', component: RenewalComponent},
  {path: 'requestcopy/:id', component: RequestCopyComponent},
  {path: 'paymentconfirmation/:id', component: ExternalPaymentComponent},
  {path: 'paymentfailed/:id', component: PaymentfailedComponent},
  {path: 'mailedpaymentconfirmation/:id', component: MailinPaymentConfirmationComponent},
  {path: 'exemptionpaynow/:id', component: ExemptionPayNowComponent},
  {path: 'registrydownload/:id', component: RegistryDownloadComponent},
  {path: 'registrydownloadpaynow/:id', component: RegistryDownloadPaymentComponent},
  {path: 'downloadpaymentconfirmation/:id', component: DownloadpaymentconfirmationComponent},
  {path: 'downloadpaymentfailed/:id', component: DownloadpaymentfailedComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
